import { css } from 'styled-components'

export const CKEditorStyles = css`
  .ck.ck-balloon-panel {
    z-index: 1301 !important
  }
`
